import { render, staticRenderFns } from "./TotalPremiumVolume.vue?vue&type=template&id=252a8f08"
import script from "./TotalPremiumVolume.vue?vue&type=script&lang=js"
export * from "./TotalPremiumVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports